import { Select } from "antd";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type Props = {
    startTime: string | number;
    listHeight?: number;
    className?: string;
    dropdownClassName?: string;
    suffixIcon?: React.ReactNode,
    onChange: (value: string) => void;
}

const TimePicker = ({ startTime, listHeight = 250, className = '', dropdownClassName = '', suffixIcon = null, onChange }: Props) => {

    const { t } = useTranslation();

    const TIME_OPTIONS: { value: string; label: string }[] = useMemo(() => {
        const options: { value: string; label: string }[] = [];

        for (let minutes = 7 * 60; minutes <= 17 * 60; minutes += 30) {
            const hour = Math.floor(minutes / 60);
            const minute = minutes % 60;

            const period = hour >= 12 ? 'PM' : 'AM';
            const displayHour = hour % 12 || 12;

            options.push({
                label: `${displayHour}:${minute
                    .toString()
                    .padStart(2, '0')} ${period}`,
                value: `${hour
                    .toString()
                    .padStart(2, '0')}:${minute.toString().padStart(2, '0')}`
            });
        }

        return options;
    }, []);

    const selectTime = startTime ? startTime.toString() : undefined;

    return <Select {...{ className, listHeight, dropdownClassName, suffixIcon, onChange }} value={selectTime} placeholder={t("phishingManager.campaignSetup.step4.selectTime")} options={TIME_OPTIONS} getPopupContainer={(trigger) => trigger.parentElement}
    />
}

export default TimePicker;